import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

export function AuthLayout() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen flex" style={{ backgroundColor: 'var(--background-main)' }}>
      {/* Left side - decorative */}
      <div 
        className="hidden lg:flex lg:w-1/2 flex-col justify-center items-center p-12"
        style={{ backgroundColor: 'var(--background-aside-primary)' }}
      >
        <div className="max-w-md text-center">
          <div className="mb-8">
            <svg
              viewBox="0 0 100 100"
              className="w-24 h-24 mx-auto"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="50" cy="50" r="45" stroke="white" strokeWidth="3" />
              <path
                d="M30 50 L45 65 L70 35"
                stroke="white"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <h1 className="text-4xl font-bold text-white mb-4">TOTAROS</h1>
          <p className="text-xl text-blue-100 mb-8">
            クラウド統合会計・税務システム
          </p>
          <div className="space-y-4 text-left text-blue-100">
            <div className="flex items-center gap-3">
              <span className="text-2xl">📊</span>
              <span>AIによる自動仕訳・科目推論</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-2xl">📷</span>
              <span>証憑OCRで電子帳簿保存法対応</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-2xl">📝</span>
              <span>法人税・消費税申告書作成</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-2xl">🔒</span>
              <span>e-Tax電子申告連携</span>
            </div>
          </div>
        </div>
      </div>

      {/* Right side - auth form */}
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

